export enum QueryKey {
  Agreements = 'agreements',
  BannersData = 'bannersData',
  DashboardData = 'dashboardData',
  Events = 'events',
  Event = 'event',
  TrainerMetric = 'TrainerMetric',
  EnrollEventSurveyData = 'enrollEventSurveyData',
  NewPassword = 'newPassword',
  UserFacsimile = 'userFacsimile',
  SurveyList = 'surveyList',
  KnowledgeBaseData = 'knowledgeBaseData',
  UsersAdministrationUserDetails = 'usersAdministrationUserDetails',
  UsersAdministrationCompanyList = 'usersAdministrationCompanyList',
  UsersAdministrationCyclicalLessons = 'usersAdministrationCyclicalLessons',
  UsersAdministrationUsersList = 'usersAdministrationUsersList',
  UsersAdministrationCoursesList = 'usersAdministrationCoursesList',
  UsersAdministrationDashboardStatistics = 'usersAdministrationDashboardStatistics',
  UsersAdministrationActiveCertificates = 'usersAdministrationActiveCertificates',
  SubstitutionsCreateAvailableUsers = 'substitutionsCreateAvailableUsers',
  SubstitutionsCreateStationsToCover = 'substitutionsCreateStationsToCover',
  SubstitutionsListAccepted = 'substitutionsListAccepted',
  SubstitutionsListRequested = 'substitutionsListRequested',
  SubstitutionsListRequestedByMe = 'substitutionsListRequestedByMe',
  SubstitutionsStatistics = 'substitutionsStatistics',
  SubstitutionsCompaniesList = 'substitutionsCompaniesList',
  SubstitutionsList = 'SubstitutionsList',
  UserExperience = 'userExperience',
  Notifications = 'notifications',
  UserInfo = 'userInfo',
  DocumentArchiveList = 'documentArchiveList',
  SearchResults = 'searchResults',
  SearchNewsResults = 'searchNewsResults',
  LegalFormsFormStructure = 'legalFormsFormStructure',
  LegalFormsCompanyAgents = 'legalFormsCompanyAgents',
  LegalFormsAttemptsList = 'legalFormsAttemptsList'
}
